import * as actions from '../actions/expenseTypes';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function requestGetExpenseTypes(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_EXPENSE_TYPES)
        .map(action => ({
            url: BASE_URL + 'api/Groups/ExpenseTypes',
            category: 'requestGetExpenseTypes',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestGetExpenseTypes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveExpenseTypes(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveErrorGetExpenseTypes(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestGetExpenseTypes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveExpenseTypes(response));

    return {
        ACTION: httpResponse$
    };
}
